import { userConstants } from "../constants";
import { reject, differenceBy } from "lodash";

const usersReducer = (
  state = {
    usersDetails: [],
    totalUsers: 0,
    addableUsers: {
      list: [],
      listLoaded: [],
      chosen: [],
      moreToLoad: true,
    },
    usersRequest: [],
    loading: false,
    saving: false,
  },
  action,
) => {
  switch (action.type) {
    case userConstants.RESTOREADDABLEUSERSLOADED:
      return {
        ...state,
        addableUsers: {
          list: state.addableUsers.listLoaded,
          chosen: state.addableUsers.chosen,
          listLoaded: state.addableUsers.listLoaded,
          moreToLoad: state.addableUsers.moreToLoad,
        },
      };

    case userConstants.ADDABLEUSERSMORETOLOAD:
      return {
        ...state,
        addableUsers: {
          list: state.addableUsers.list,
          chosen: state.addableUsers.chosen,
          listLoaded: state.addableUsers.listLoaded,
          moreToLoad: true,
        },
      };

    case userConstants.CONFIRMCHOSEN:
    /*return {
					...state,
					addableUsers:{
						list: [...state.addableUsers.list, ...state.addableUsers.chosen],
						chosen: []
					}
				};*/

    case userConstants.ADDCHOSENONE:
      if (
        state.addableUsers.chosen.filter((x) => x.Id == action.payload.id)
          .length == 0
      ) {
        return {
          ...state,
          addableUsers: {
            list: state.addableUsers.list,
            chosen: [
              ...state.addableUsers.chosen,
              state.addableUsers.list.filter(
                (x) => x.Id == action.payload.id,
              )[0],
            ],
            listLoaded: state.addableUsers.listLoaded,
            moreToLoad: state.addableUsers.moreToLoad,
          },
        };
      } else
        return {
          ...state,
          addableUsers: {
            list: state.addableUsers.list,
            chosen: state.addableUsers.chosen,
            listLoaded: state.addableUsers.listLoaded,
            moreToLoad: state.addableUsers.moreToLoad,
          },
        };

    case userConstants.REMOVECHOSENONE:
      if (state.addableUsers.chosen.filter((x) => x.Id == action.payload.id)) {
        return {
          ...state,
          addableUsers: {
            list: state.addableUsers.list,
            chosen: state.addableUsers.chosen.filter(
              (x) => x.Id != action.payload.id,
            ),
            listLoaded: state.addableUsers.listLoaded,
            moreToLoad: state.addableUsers.moreToLoad,
          },
        };
      } else
        return {
          ...state,
          addableUsers: {
            list: this.state.addableUsers.list,
            chosen: this.state.addableUsers.chosen,
            listLoaded: state.addableUsers.listLoaded,
            moreToLoad: state.addableUsers.moreToLoad,
          },
        };

    case userConstants.GETBYID_REQUEST:
      return {
        ...state,
        usersRequest: [...state.usersRequest, action.payload.id],
        loading: true,
      };

    case userConstants.GETBYID_SUCCESS:
      return {
        ...state,
        usersDetails: state.usersDetails.find((x) => x.Id === action.payload.id)
          ? state.usersDetails.map((x) =>
              action.payload.user && action.payload.user.Id !== x.Id
                ? x
                : action.payload.user,
            )
          : [...state.usersDetails, action.payload.user],
        usersRequest: state.usersRequest.filter((x) => x != action.payload.id),
        loading: false,
      };

    case userConstants.GETBYID_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        usersRequest: state.usersRequest.filter((x) => x != action.payload.id),
        loading: false,
      };

    case userConstants.GETBYEMAIL_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case userConstants.GETBYEMAIL_SUCCESS:
      return {
        ...state,
        usersDetails: action.payload.user
          ? [
              ...state.usersDetails.filter(
                (x) => action.payload.user.Id !== x.Id,
              ),
              action.payload.user,
            ]
          : state.usersDetails,
        loading: false,
      };

    case userConstants.GETBYEMAIL_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        loading: false,
      };

    case userConstants.CLEARLIST_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case userConstants.CLEARLIST_SUCCESS:
      return {
        ...state,
        usersDetails: [],
        totalUsers: 0,
        loading: false,
      };

    case userConstants.CLEARLIST_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        loading: false,
      };

    case userConstants.GETPAGINATED_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case userConstants.GETPAGINATED_SUCCESS:
      return {
        ...state,
        usersDetails: action.payload.clear
          ? action.payload.data.rows
          : [
              ...state.usersDetails.filter(
                (x) => !action.payload.data.rows.find((y) => y.Id == x.Id),
              ),
              ...action.payload.data.rows,
            ],
        totalUsers: action.payload.data.total,
        loading: false,
      };

    case userConstants.GETPAGINATED_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        loading: false,
      };

    case userConstants.CLEARADDABLEUSERS:
      return {
        ...state,
        addableUsers: {
          moreToLoad: true,
          list: [],
          listLoaded: [],
          chosen: [],
        },
      };

    case userConstants.GETNUSERS_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case userConstants.GETNUSERS_SUCCESS:
      var poppedList = action.payload.users;
      var moreToLoad = false;
      if (poppedList.length > 30) {
        poppedList.pop();
        moreToLoad = true;
      }

      var usersAddableDifference = differenceBy(
        poppedList,
        state.addableUsers.list,
        "Id",
      );

      var usersListDifference = differenceBy(
        poppedList,
        state.usersDetails,
        "Id",
      );
      return {
        ...state,
        usersDetails: [...state.usersDetails, ...usersListDifference],
        addableUsers: {
          list: [...state.addableUsers.list, ...usersAddableDifference],
          chosen: state.addableUsers.chosen,
          listLoaded: [...state.addableUsers.list, ...usersAddableDifference],
          moreToLoad: moreToLoad,
        },
        loading: false,
      };

    case userConstants.GETNUSERS_FAILURE:
      return {
        ...state,
        addableUsers: {
          list: state.addableUsers.list,
          chosen: state.addableUsers.chosen,
          listLoaded: state.addableUsers.list,
          moreToLoad: false,
        },
        error: action.payload.error,
        loading: false,
      };

    case userConstants.ADDABLEUSERSBYSTRING_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case userConstants.ADDABLEUSERSBYSTRING_SUCCESS:
      return {
        ...state,
        addableUsers: {
          list: action.payload.users,
          chosen: state.addableUsers.chosen,
          listLoaded: state.addableUsers.listLoaded,
          moreToLoad: state.addableUsers.moreToLoad,
        },
        loading: false,
      };

    case userConstants.ADDABLEUSERSBYSTRING_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        loading: false,
      };

    case userConstants.GETALL_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case userConstants.GETALL_SUCCESS:
      return {
        ...state,
        usersDetails: action.payload.users,
        totalUsers: action.payload.users.length,
        loading: false,
      };

    case userConstants.GETALL_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        loading: false,
      };

    case userConstants.GETDETAILS_REQUEST:
      return {
        ...state,
        usersRequest: state.usersRequest.concat(action.payload.ids),
        loading: true,
      };

    case userConstants.GETDETAILS_SUCCESS:
      return {
        ...state,
        usersDetails: action.payload.users
          ? [
              ...action.payload.users,
              ...state.usersDetails.filter(
                (x) => !action.payload.users.find((y) => y.Id === x.Id),
              ),
            ]
          : state.usersDetails,
        usersRequest: state.usersRequest.filter(
          (x) => !action.payload.ids.includes(x),
        ),
        loading: false,
      };

    case userConstants.GETDETAILS_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        usersRequest: state.usersRequest.filter(
          (x) => !action.payload.ids.includes(x),
        ),
        loading: false,
      };

    case userConstants.RESETDETAILS:
      return {
        ...state,
        usersDetails: [],
      };

    case userConstants.RESETME:
      return {
        ...state,
        me: [],
      };

    case userConstants.MYPROFILE_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case userConstants.MYPROFILE_SUCCESS:
      return {
        ...state,
        me: action.payload.user,
        usersDetails: [
          ...state.usersDetails.filter(
            (user) => action.payload.user.Id !== user.Id,
          ),
          action.payload.user,
        ],
        loading: false,
      };

    case userConstants.MYPROFILE_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        loading: false,
      };

    case userConstants.UPDATE_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case userConstants.UPDATE_SUCCESS:
      const { id, user } = action.payload;
      let me = state.me;

      // update also me if it's my user
      if (id === state.me.Id) {
        me = user;
      }

      return {
        ...state,
        me,
        usersDetails: state.usersDetails.map((x) =>
          x.Id !== user.Id ? x : user,
        ),
        loading: false,
      };

    case userConstants.UPDATE_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        loading: false,
      };

    case userConstants.DELETE_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case userConstants.DELETE_SUCCESS:
      return {
        ...state,
        usersDetails: state.usersDetails.filter(
          (user) => action.payload.idDel !== user.Id,
        ),
        totalUsers: state.totalUsers - 1,
        loading: false,
      };

    case userConstants.DELETE_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        loading: false,
      };

    case userConstants.ADD_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case userConstants.ADD_SUCCESS:
      return {
        ...state,
        usersDetails: [
          ...state.usersDetails.filter(
            (x) => !action.payload.user || x.Id !== action.payload.user.Id,
          ),
          action.payload.user,
        ],
        totalUsers: state.totalUsers + 1,
        loading: false,
      };

    case userConstants.ADD_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        loading: false,
      };

    case userConstants.FAVOURITEBOARD_REQUEST:
      return {
        ...state,
        loading: true,
        saving: true,
      };

    case userConstants.FAVOURITEBOARD_SUCCESS:
      return {
        ...state,
        usersDetails: [
          ...state.usersDetails.filter((user) => user.Id !== state.me.Id),
          {
            ...state.me,
            FavouriteBoards: action.payload.star
              ? [...state.me.FavouriteBoards, action.payload.boardId]
              : state.me.FavouriteBoards.filter(
                  (x) => x != action.payload.boardId,
                ),
          },
        ],
        me: {
          ...state.me,
          FavouriteBoards: action.payload.star
            ? [...state.me.FavouriteBoards, action.payload.boardId]
            : state.me.FavouriteBoards.filter(
                (x) => x != action.payload.boardId,
              ),
        },
        loading: false,
        saving: false,
      };

    case userConstants.FAVOURITEBOARD_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        loading: false,
        saving: false,
      };

    case userConstants.CHANGEPASSWORD_REQUEST:
      return {
        ...state,
        loading: true,
        saving: true,
      };

    case userConstants.CHANGEPASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        saving: false,
      };

    case userConstants.CHANGEPASSWORD_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        loading: false,
        saving: false,
      };

    case userConstants.RESETPASSWORD_REQUEST:
      return {
        ...state,
        loading: true,
        saving: true,
      };

    case userConstants.RESETPASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        saving: false,
      };

    case userConstants.RESETPASSWORD_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        loading: false,
        saving: false,
      };

    case userConstants.AVATAR_REQUEST:
      return {
        ...state,
        loading: true,
        saving: true,
      };

    case userConstants.AVATAR_SUCCESS:
      return {
        ...state,
        usersDetails: state.usersDetails.map((user) =>
          user.Id === action.payload.userId
            ? {
                ...user,
                AvatarS: action.payload.file.Path,
                AvatarM: action.payload.file.Path,
              }
            : user,
        ),
        me:
          state.me.Id == action.payload.userId
            ? {
                ...state.me,
                AvatarS: action.payload.file.Path,
                AvatarM: action.payload.file.Path,
              }
            : state.me,
        loading: false,
        saving: false,
      };

    case userConstants.AVATAR_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        loading: false,
        saving: false,
      };

    case userConstants.REGISTER_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case userConstants.REGISTER_SUCCESS:
      return {
        ...state,
        loading: false,
      };

    case userConstants.REGISTER_FAILURE:
      return {
        ...state,
        loading: false,
      };

    case userConstants.ACTIVATE_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case userConstants.ACTIVATE_SUCCESS:
      return {
        ...state,
        loading: false,
      };

    case userConstants.ACTIVATE_FAILURE:
      return {
        ...state,
        loading: false,
      };

    default:
      return state;
  }
};

export default usersReducer;
